import React from "react";

import { MissingShopifyScopeDialog } from "../components/Dialogs/MissingShopifyScopeDialog";
import { ScriptTagDialog } from "../components/Dialogs/ScriptTagDialog";
import { UpdateDetectedDialog } from "../components/Dialogs/UpdatedDetectedDialog";
import { FreeTrialAlert } from "../components/MainApp/Alerts/FreeTrial";
import { ScriptStatusAlert } from "../components/MainApp/Alerts/ScriptStatusAlert";
import { OnboardingFlow } from "../components/MainApp/Onboarding";

export const DialogProvider = () => {
  return (
    <>
      <MissingShopifyScopeDialog />
      <UpdateDetectedDialog />
      <ScriptTagDialog />
      <OnboardingFlow />
    </>
  );
};
